<template>
  <div>
    <div class="px-3 py-2">
      <div class="d-flex">
        <div class="btn-home mb-4 ms-auto">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100">
          <div class="card-header text-white h4 text-center" style="background: #900052">
            <strong>KARDEX</strong>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <!--Filtro-->
              <div class="col-md-12 py-2">
                <div class="row d-flex">
                  <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">SELECIONE UN MES</span>
                      <v-select class="text-dark form-control" label="name" :options="months"
                        placeholder="- Seleccionar Mes -" v-model="filter.monthRange" :reduce="(name) => name.id"
                        required :clearable="false">
                        <template slot="no-options">
                          No hay Meses para la busqueda.
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">SELECCIÓN AÑO</span>
                      <v-select class="text-dark form-control" label="Year" :options="nextThreeYears"
                        placeholder="- Seleccionar Año -" v-model="selectedYear" required :clearable="false">
                        <template slot="no-options">
                          No hay Años para la busqueda.
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-1">
                    <button class="btn btn-sm w-100 text-white w-100 py-2" style="background: #900052"
                      @click="mtdGetData" :disabled="mtddisable">
                      <i class="fas fa-search"></i>&nbsp;Buscar
                    </button>
                  </div>
                  <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">BUSCAR PRODUCTO</span>
                      <input type="text" class="form-control" placeholder="Buscar por nombre..." v-model="filterName" />
                    </div>
                  </div>

                  <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <button class="btn btn-sm w-100 text-white w-100 py-2" style="background: #900052"
                      @click="viewpdf()" :disabled="mtddisable">
                      <i class="fal fa-file-pdf" style="font-size: 18px"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!--Fin Filtro-->

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-4" id="content-timelinetable"
                v-if="showTable">
                <table id="tb-cxc" class="table table-bordered border-main align-middle">
                  <thead>
                    <tr class="text-white border-white text-center" style="background: #900052; vertical-align: middle">
                      <th scope="col" colspan="1" rowspan="2">FECHA</th>
                      <th scope="col" colspan="1" rowspan="2">TIPO DOC.</th>
                      <th scope="col" colspan="1" rowspan="2">
                        SERIE Y N° DE DOC.
                      </th>
                      <!-- <th scope="col" colspan="1" rowspan="2">LOTE</th> -->
                      <th scope="col" colspan="1" rowspan="2">TIPO OPE.</th>
                      <th scope="col" colspan="3">INGRESOS</th>
                      <th scope="col" colspan="3">SALIDAS</th>
                      <th scope="col" colspan="3">SALDO</th>
                    </tr>
                    <tr class="text-white border-white text-center" style="background: #900052; vertical-align: middle">
                      <th scope="col">Cantidad</th>
                      <th scope="col">Costo Unit.</th>
                      <th scope="col">Costo Total</th>
                      <th scope="col">Cantidad</th>
                      <th scope="col">Costo Unit.</th>
                      <th scope="col">Costo Total</th>
                      <th scope="col">Cantidad</th>
                      <th scope="col">Costo Unit.</th>
                      <th scope="col">Costo Total</th>
                    </tr>
                  </thead>

                  <tbody class="custom-table">
                    <tr class="text-center" style="
                        vertical-align: middle;
                        color: #900052;
                        background: #f3e2ec;
                      ">
                      <th scope="col" colspan="5" style="font-style: italic">
                        *** TOTALES
                      </th>
                      <th scope="col">{{ getGrandTotalEntrada() }}</th>
                      <th scope="col" colspan="2">-</th>
                      <th scope="col">{{ getGrandTotalSalida() }}</th>
                      <th scope="col" colspan="2">-</th>
                      <th scope="col" colspan="3" style="font-style: italic">{{ getGrandSaldoFinal() }}</th>
                    </tr>
                  </tbody>

                  <tbody v-for="(product, productId) in filteredDataCxcs" :key="'product_group_' + productId"
                    class="custom-table">
                    <tr class="text-center">
                      <th scope="col" colspan="14">{{ product.name }}</th>
                    </tr>
                    <tr v-for="(item, index) in getProductItemsForTable(product)"
                      :key="'item_' + productId + '_' + index" class="text-center">
                      <template v-if="index == 0">
                        <td colspan="3">INVENTARIO</td>
                        <td>
                          <span class="badge text-bg-primary">INVENTARIO</span>
                        </td>
                        <td>{{ item.quantity }}</td>
                        <td colspan="2">-</td>
                        <td colspan="3">-</td>
                        <td>{{ item.quantity }}</td>
                        <td>-</td>
                        <td>-</td>
                      </template>
                      <template v-else>
                        <td>{{ item.date | formatDate }}</td>
                        <td>
                          {{ item.document_type || "-" }}
                        </td>
                        <td>{{ item.document || "-" }}</td>
                        <!-- <td>{{ item.lote || "-" }}</td> -->
                        <td>
                          <span :class="operationClass(item.type)"
                            @click="openModal(item.dispatch_detail_id, item.sale_id, product.name, item.lote, item.id, product.id)">
                            {{ operationLabel(item.type) }}
                          </span>
                        </td>
                        <td>
                          {{ isEntradaType(item.type) ? parseInt(item.quantity) : "-" }}
                        </td>
                        <td>
                          {{ isEntradaType(item.type) ? item.price_cost : "-" }}
                        </td>
                        <td>
                          {{ isEntradaType(item.type) ? formatPriceTotal(item) : "-" }}
                        </td>
                        <td>
                          {{ isSalidaType(item.type) ? parseInt(item.quantity) : "-" }}
                        </td>
                        <td>
                          {{ isSalidaType(item.type) ? item.price_cost : "-" }}
                        </td>
                        <td>
                          {{ isSalidaType(item.type) ? formatPriceTotal(item) : "-" }}
                        </td>
                        <td>{{ item.balance }}</td>
                        <td>{{ item.price_cost }}</td>
                        <td>{{ formatBalanceTotal(item) }}</td>
                      </template>
                    </tr>
                    <tr class="text-center" style="
                        vertical-align: middle;
                        color: #900052;
                        background: #fdfae3;
                      ">
                      <th scope="col" colspan="5" style="font-style: italic">
                        *** TOTAL
                      </th>
                      <th scope="col">{{ getProductTotalEntrada(product) }}</th>
                      <th scope="col" colspan="2">-</th>
                      <th scope="col">{{ getProductTotalSalida(product) }}</th>
                      <th scope="col" colspan="2">-</th>
                      <th scope="col" style="font-style: italic">{{ getProductFinalBalance(product) }}</th>
                      <th scope="col" colspan="2">-</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cModalDetKarVue :title="modalDetKar.title" :boo_modal="modalDetKar.modal_form" :dataDis="modalDetKar.dataDis"
      :dataSal="modalDetKar.dataSal" :dataDePhar="modalDetKar.dataDePhar" :dataFactura="modalDetKar.dataFactura"
      :dataNoteDet="modalDetKar.dataNoteDet" :namePro="modalDetKar.namePro" :lotePro="modalDetKar.lotePro"
      @closeModalDetKar="closeModalDetKar" />
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalDetKarVue from "../modals/Kardex/cModalDetKar.vue";

export default {
  name: "kardex-report",
  components: {
    SweetAlert,
    cModalDetKarVue,
  },
  data() {
    return {
      swal: null,
      search: "",
      filterName: "",
      dataShow: [],
      dataCxcs: [],
      selectPage: 1,
      noRecordsMessage: "",
      filter: {
        init: "",
        end: "",
        monthRange: null,
      },
      stepPagination: [],
      servicesProd: [],
      selectedProd: "",
      totals: [],
      lastSearchMonth: null,
      lastSearchYear: null,

      selectedYear: null,
      nextThreeYears: [],
      months: [
        { id: 1, name: "Enero" },
        { id: 2, name: "Febrero" },
        { id: 3, name: "Marzo" },
        { id: 4, name: "Abril" },
        { id: 5, name: "Mayo" },
        { id: 6, name: "Junio" },
        { id: 7, name: "Julio" },
        { id: 8, name: "Agosto" },
        { id: 9, name: "Septiembre" },
        { id: 10, name: "Octubre" },
        { id: 11, name: "Noviembre" },
        { id: 12, name: "Diciembre" },
      ],
      showTable: false,
      registerKar: [],

      modalDetKar: {
        title: "DETALLE DE KARDEX",
        dataDis: [],
        dataFactura: [],
        dataSal: [],
        dataDePhar: [],
        dataNoteDet: [],
        namePro: "",
        lotePro: "",
        modal_form: false,
      },
    };
  },
  mounted() {
    this.populateNextThreeYears();
  },
  computed: {
    mtddisable() {
      return !(this.filter.monthRange != null && this.selectedYear != null);
    },
    filteredDataCxcs() {
      if (!this.filterName || this.filterName.trim() == "") {
        return this.dataCxcs;
      }
      const search = this.filterName.trim().toLowerCase();
      return this.dataCxcs.filter((product) =>
        product.name && product.name.toLowerCase().includes(search)
      );
    },
  },
  created() {
    moment.locale("es");
    this.filter.end =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-" +
      moment().format("L").substr(0, 2);
    this.filter.init = this.filter.end;
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/Kardex/index",
        token: this.$store.getters.get__token,
        params: {
          month: this.filter.monthRange,
          anio: this.selectedYear,
        },
      })
        .then((response) => {
          this.dataCxcs = response.data.kardex;
          console.log(this.dataCxcs);

          this.totals = response.data.totals;
          this.lastSearchMonth = parseInt(this.filter.monthRange);
          this.lastSearchYear = parseInt(this.selectedYear);
          if (this.dataCxcs.length == 0) {
            this.showTable = false;
            this.noRecordsMessage = "No se encontraron Resultados";
            this.$refs.SweetAlert.showWarning("Sin Datos");
          } else {
            this.showTable = true;
            this.noRecordsMessage = "";
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    openModal: function (idDis, idSale, name, lote, id, idPd) {
      this.post({
        url: this.$store.getters.get__url + "/Kardex/openDetKardex",
        token: this.$store.getters.get__token,
        params: {
          idDis: idDis,
          idSale: idSale,
          idKa: id,
          idPd: idPd,
        },
      })
        .then((response) => {
          this.modalDetKar = {
            title: "DETALLE DE KARDEX",
            modal_form: true,
            dataDis: response.data.dataDis,
            dataFactura: response.data.dataFactura,
            dataSal: response.data.dataSal,
            dataDePhar: response.data.dataDePhar,
            dataNoteDet: response.data.dataNoteDet,
            namePro: name,
            lotePro: lote,
          };
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    closeModalDetKar: function () {
      this.modalDetKar = {
        title: "DETALLE DE KARDEX",
        modal_form: false,
        dataFactura: [],
        dataDis: [],
        dataSal: [],
        dataDePhar: [],
        dataNoteDet: [],
        namePro: "",
        lotePro: "",
      };
    },

    viewpdf: function () {
      window.open(
        this.$store.getters.get__url +
        "/Kardex/viewpdf/" +
        this.filter.monthRange +
        "/" +
        this.selectedYear,
        "_blank"
      );
    },

    populateNextThreeYears() {
      const currentYear = new Date().getFullYear();
      for (let i = 0; i < 3; i++) {
        this.nextThreeYears.push(currentYear - i);
      }
    },

    returnHome: function () {
      this.$emit("returnHome");
    },

    stateType(state) {
      switch (state) {
        case 1:
          return "FACTURA";
        case 2:
          return "BOLETA";
        default:
          /*  return "NOTA DE INGRESO"; */
          return "EXCEL";
      }
    },
    isEntradaType(type) {
      return type == 1 || type == 4;
    },
    isSalidaType(type) {
      return type == 2 || type == 3;
    },
    operationLabel(type) {
      switch (type) {
        case 1:
          return "ENTRADA";
        case 2:
          return "SALIDA";
        case 3:
          return "SALIDA";
        case 4:
          return "DEVOLUCION";
        default:
          return "MOVIMIENTO";
      }
    },
    operationClass(type) {
      if (this.isSalidaType(type)) {
        return "badge text-bg-danger";
      }
      if (this.isEntradaType(type)) {
        return "badge text-bg-success";
      }
      return "badge text-bg-primary";
    },
    formatPriceTotal(item) {
      if (item.price_total != null && item.price_total !== "") {
        return parseFloat(item.price_total).toFixed(3);
      }
      const quantity = parseFloat(item.quantity || 0);
      const priceCost = parseFloat(item.price_cost || 0);
      return (quantity * priceCost).toFixed(3);
    },
    formatBalanceTotal(item) {
      const balance = parseFloat(item.balance || 0);
      const priceCost = parseFloat(item.price_cost || 0);
      return (balance * priceCost).toFixed(3);
    },
    isFutureMonthSelected() {
      const selectedMonth = this.lastSearchMonth;
      const selectedYear = this.lastSearchYear;

      if (!selectedMonth || !selectedYear) {
        return false;
      }
      const currentMonth = moment().month() + 1;
      const currentYear = moment().year();

      if (selectedYear > currentYear) {
        return true;
      }
      return selectedYear === currentYear && selectedMonth > currentMonth;
    },
    getFirstItem(product) {
      if (!product || !product.items || product.items.length === 0) {
        return null;
      }
      return product.items[0];
    },
    getInventoryValue(product) {
      const firstItem = this.getFirstItem(product);
      if (!firstItem) {
        return 0;
      }
      if (this.isFutureMonthSelected()) {
        return parseInt(firstItem.balance || 0);
      }
      return parseInt(firstItem.old_quantity || 0);
    },
    getProductItemsForTable(product) {
      if (!product || !Array.isArray(product.items)) {
        return [];
      }
      if (this.isFutureMonthSelected()) {
        return product.items.slice(1);
      }
      return product.items;
    },
    getProductTotalEntrada(product) {
      if (!product || !Array.isArray(product.items)) {
        return 0;
      }
      const inventory = this.getInventoryValue(product);
      const totalEntradaMov = this.getProductItemsForTable(product)
        .filter((item) => this.isEntradaType(item.type))
        .reduce((acc, item) => acc + parseFloat(item.quantity || 0), 0);
      return parseFloat((inventory + totalEntradaMov).toFixed(3));
    },
    getProductTotalSalida(product) {
      if (!product || !Array.isArray(product.items)) {
        return 0;
      }
      const totalSalidaMov = this.getProductItemsForTable(product)
        .filter((item) => this.isSalidaType(item.type))
        .reduce((acc, item) => acc + parseFloat(item.quantity || 0), 0);
      return parseFloat(totalSalidaMov.toFixed(3));
    },
    getProductFinalBalance(product) {
      if (!product || !Array.isArray(product.items) || product.items.length === 0) {
        return 0;
      }
      const visibleItems = this.getProductItemsForTable(product);
      if (visibleItems.length === 0) {
        return this.getInventoryValue(product);
      }
      const lastItem = visibleItems[visibleItems.length - 1];
      return parseFloat(lastItem.balance || 0);
    },
    getGrandTotalEntrada() {
      return this.filteredDataCxcs.reduce(
        (acc, product) => acc + this.getProductTotalEntrada(product),
        0
      );
    },
    getGrandTotalSalida() {
      return this.filteredDataCxcs.reduce(
        (acc, product) => acc + this.getProductTotalSalida(product),
        0
      );
    },
    getGrandSaldoFinal() {
      return this.filteredDataCxcs.reduce(
        (acc, product) => acc + this.getProductFinalBalance(product),
        0
      );
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null
        ? moment(dateTime).format("DD/MM/YYYY HH:mm")
        : "-";
    },
  },
};
</script>

<style scoped>
.custom-table th,
.custom-table td {
  font-size: 11px;
}
</style>